import type { TFunction } from 'i18next';
import { getErrorMessage } from '../../../utils/api';

/**
 * Resolve a perfReview-specific error to a localized message.
 *
 * The backend wraps validation failures in `{ message, code, details }`. When
 * we recognise the `code`, we look up a translation under
 * `perfReview.errors.<code>` and interpolate `details`. Otherwise we fall
 * back to the generic `getErrorMessage` (which still pulls the backend's
 * raw `message` out of the response body).
 */
export function perfReviewErrorMessage(t: TFunction, error: unknown, fallback = ''): string {
  const resp = (
    error as { response?: { data?: { code?: string; details?: Record<string, unknown> } } }
  )?.response?.data;
  const code = resp?.code;
  if (code) {
    const key = `perfReview.errors.${code}`;
    const localized = t(key, { ...(resp?.details || {}), defaultValue: '' });
    if (localized) return localized;
  }
  return getErrorMessage(error, fallback);
}
